import type { Authority } from 'Services/common/Features/Authority/types'
import { createBaseApi } from 'Util/ApiClient'

enum TagTypes {
  Authority = 'Authority'
}

export const authorityApi = createBaseApi({
  reducerPath: 'authorityApi',
  keepUnusedDataFor: 10,
  tagTypes: [TagTypes.Authority]
}).injectEndpoints({
  endpoints: builder => ({
    getAllAuthorities: builder.query<Authority[], void>({
      query: () => ({
        url: '/api/v1/authorities/'
      })
    })
  })
})

export const { useGetAllAuthoritiesQuery } = authorityApi
